import classNames from 'classnames';
import Markdown from '../markdown';

import styles from './Blocker.module.scss';
import personIcon from './icons/blocker.svg';
import shieldIcon from './icons/blocker2.svg';
import calendarIcon from './icons/blocker3.svg';
import familyIcon from './icons/blocker4.svg';

import { QuestionnaireFormProps, QuestionnaireQuestions, RoutesObject } from '../../models';
import { getButton, GetButtonProps } from '../utils/getButton';

type BlockerIconType = 'PERSON' | 'SHIELD' | 'CALENDAR' | 'FAMILY' | 'NONE';

const blockerIconMapping: Record<BlockerIconType, React.ReactNode> = {
  PERSON: <img src={personIcon} alt="person icon" />,
  SHIELD: <img src={shieldIcon} alt="shield icon" />,
  CALENDAR: <img src={calendarIcon} alt="shield icon" />,
  FAMILY: <img src={familyIcon} width="92" alt="family icon" />,
  NONE: null,
};

type BlockerProps<Questionnaire extends QuestionnaireQuestions> = {
  title: string;
  description: string;
  additionalInfo?: string;
  paragraphClassName?: string;
  iconType?: BlockerIconType;
  buttonProps: GetButtonProps[];
  routes?: RoutesObject<Questionnaire>;
  navigateTo?: (path: string) => void;
} & QuestionnaireFormProps<Questionnaire>;

export const Blocker = <Questionnaire extends QuestionnaireQuestions>({
  title,
  description,
  additionalInfo,
  paragraphClassName = '',
  iconType = 'PERSON',
  buttonProps,
  onSubmitValue,
  routes,
  navigateTo
}: BlockerProps<Questionnaire>) => {
  const navigateToQuestionId = (questionId: string) => { 
    const navigateRoute = routes?.[questionId]?.path;

    if (navigateRoute && navigateTo) {
      navigateTo?.(navigateRoute);
    }
  }

  return (
    <div
      className={`p-container d-flex fd-column ai-center jc-center ${styles.container}`}
    >
      {blockerIconMapping[iconType]}
      <h1 className="p-h1 mt16 mb8 ta-center">{title}</h1>
      <Markdown
        paragraphClassName={`p-p ta-center ${paragraphClassName}`}
        openLinksInNewTab
      >
        {description}
      </Markdown>
      <div
        className={classNames(
          'd-flex fd-column gap16 mt24 ai-center jc-center',
          styles.buttonContainer
        )}
      >
        {buttonProps.map((buttonBlockerProps, index) =>
          getButton({index, ...buttonBlockerProps, navigateToQuestionId, onSubmitValue })
        )}
      </div>
      {additionalInfo && (
        <Markdown
          className="mt24"
          paragraphClassName={`p-p ta-center ${paragraphClassName}`}
          openLinksInNewTab
        >
          {additionalInfo}
        </Markdown>
      )}
    </div>
  );
}
